import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Clienti from "./pages/Clienti";
import ClienteDetail from "./pages/ClienteDetail";
import DatiOttici from "./pages/DatiOttici";
import Marketing from "./pages/Marketing";
import LogAttivita from "./pages/LogAttivita";
import Impostazioni from "./pages/Impostazioni";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F172A]">
        <div className="text-white/70 font-head animate-pulse">Caricamento…</div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="clienti" element={<Clienti />} />
        <Route path="clienti/:id" element={<ClienteDetail />} />
        <Route path="dati-ottici" element={<DatiOttici />} />
        <Route path="marketing" element={<Marketing />} />
        <Route path="log" element={<LogAttivita />} />
        <Route path="impostazioni" element={<Impostazioni />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
